import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import type { FormControl } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tla-start-free-trial-dialog-chips-lib',
  styleUrls: ['./start-free-trial-dialog-chips.component.less'],
  template: `
    <rt-heading margin-bottom-small>{{
      'tl.dashboard.start_trial_dialog.config.involvements.title' | translate
    }}</rt-heading>
    <div class="chips">
      @for (element of elements(); track element.value) {
        <div
          class="chip"
          (click)="control().setValue(element.value)"
          [class.active]="control().value === element.value"
        >
          {{ element.label }}
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeadingComponent, TranslatePipe],
})
export class StartFreeTrialDialogChipsComponent {
  public control = input.required<FormControl<string | null>>();
  public elements = input.required<Array<{ value: string; label: string }>>();
}
